/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

/**
 * Platform role
 */
export type CurrentUserResponseDtoUserType =
  (typeof CurrentUserResponseDtoUserType)[keyof typeof CurrentUserResponseDtoUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrentUserResponseDtoUserType = {
  user: 'user',
  admin: 'admin',
  staff: 'staff',
} as const;
